import { ISipping, Pagination, ShippingStatus, ShippingPriority } from '../../interfaces/deliveries.interface';
import { IGetReturnByID } from '../../interfaces/returns.interface';
import { UploadProgress } from '../../services/file-upload/file-upload.service';

export namespace ReturnsActions {
  export class GetReturns {
    static readonly type = '[Returns] Get Returns';
    constructor(
      public page?: number,
      public pageSize?: number,
      public status?: ShippingStatus,
      public priority?: ShippingPriority,
      public q?: string,
      public carrier?: string,
      public driverId?: number,
    ) {}
  }

  export class SetReturns {
    static readonly type = '[Returns] Set Returns';
    constructor(public returns: Pagination<IGetReturnByID>) {}
  }

  export class GetReturnById {
    static readonly type = '[Returns] Get Return By Id';
    constructor(public id: string) {}
  }

  export class UploadReturnFile {
    static readonly type = '[Returns] Upload Return File';
    constructor(public returnId: number, public file: File) {}
  }

  export class UploadReturnFileProgress {
    static readonly type = '[Returns] Upload Return File Progress';
    constructor(public progress: UploadProgress) {}
  }

  export class UploadReturnFileSuccess {
    static readonly type = '[Returns] Upload Return File Success';
    constructor(public response: any) {}
  }

  export class UploadReturnFileError {
    static readonly type = '[Returns] Upload Return File Error';
    constructor(public error: string) {}
  }

  export class HighlightRow {
    static readonly type = '[Returns] Highlight Row';
    constructor(public id: number | null) {}
  }

  export class PatchReturn {
    static readonly type = '[Returns] Patch Return';
    constructor(public item: Partial<IGetReturnByID> & { id: number }) {}
  }
}
